import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';

import { ModalModule } from 'ngx-bootstrap/modal';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationModule } from './authentication/authentication.module';

import { SidebarModule } from './sidebar/sidebar.module';
import { FixedPluginModule } from './shared/fixedplugin/fixedplugin.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';

import { LocalUserService } from './authentication/local-user.service';
import { NotificationService }  from "./shared/notification/notification.service";

import { AppComponent } from './app.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr, 'fr');


@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    FixedPluginModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    ModalModule.forRoot(),
    AppRoutingModule,
    AuthenticationModule
  ],
  declarations: [
    AppComponent,
    LoginLayoutComponent,
    AdminLayoutComponent,
    AuthenticationComponent,
    DashboardComponent
  ],
  providers: [
    {
      provide: LOCALE_ID, useValue: 'fr'
    },
    LocalUserService,
    NotificationService
   ],
  bootstrap: [ AppComponent ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts